import { render, staticRenderFns } from "./CmgRetroCreditRestaurantSelection.vue?vue&type=template&id=38a4cc7b&scoped=true&lang=pug"
import script from "./cmg-retro-credit-restaurant-selection.ts?vue&type=script&lang=ts&external"
export * from "./cmg-retro-credit-restaurant-selection.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRetroCreditRestaurantSelection.vue?vue&type=style&index=0&id=38a4cc7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4cc7b",
  null
  
)

export default component.exports